var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReception(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 176.626,
    height: 96.618,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 176.626,
    height: 96.596,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 199,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 198,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(15 52.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M62.044,8.335c-21.583,17.121-45.1,15.5-52.235,32.682C3.852,55.353-9.615,65.167,11.191,91.454c4.319,5.457,21.558,3.828,21.558,3.828s73.1,1.268,83.378,1.267,37.345,1.293,48.885-9.568c9.033-8.5,16.723-24.952,7.328-39.1s-14-7.048-21.566-22.2C141.6,7.3,130.748-.032,115.479,1.659,101.165,3.244,80.646-6.421,62.044,8.335",
    transform: "translate(0 0)",
    fill: "#f3f8ed"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M823.906,247.339a7.949,7.949,0,0,1-.749,1.426c-2.151,3.289-6.3,4.775-8.475,9.307-2.468,5.135-4.777,10.487-5.115,13.585a4.207,4.207,0,0,0,.156,2.307c-.613-.451-2.022-1.23-2.138-4.306-.182-4.836-.443-18.25,1.172-23.326a20.941,20.941,0,0,1,2.869-5.577c1.654-2.4,3.526-4.473,4.775-6.534,2.122-3.5,4.047-4.966,6.3-2.5,2.193,2.4,2.968,11.247,1.208,15.618",
    transform: "translate(-659.259 -188.192)",
    fill: "#8cc2e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M733.146,177s3.991-6.748,4.746-13.446-3.393-20.947-4.163-28.891.665-17.467-6.316-18.344-4.391,7.746-6.771,12.593-5.262,9.167-1.966,16.985,9.562,14.649,10.9,19.493,1.106,11.6,2.754,13.014.819-1.4.819-1.4",
    transform: "translate(-585.566 -94.922)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M754.3,185.068a.175.175,0,0,0-.023-.092v0c-.407-1.612-.912-3.191-1.447-4.7-.728-2.054-1.519-4.094-2.214-6.162a.187.187,0,0,0,.034-.087,12.529,12.529,0,0,1,2.735-6.479c.148-.182-.11-.443-.259-.26a12.937,12.937,0,0,0-2.75,6.094,40.556,40.556,0,0,1-1.136-4.2,53.035,53.035,0,0,1-.612-11.8c.077-4.276.057-8.6-1.3-12.7-.074-.223-.428-.128-.354.1,2.171,6.568.878,13.5,1.343,20.267-1.387-3.117-4.912-5.079-5.866-8.493a.184.184,0,0,0-.354.1c1.14,4.078,6.046,6.122,6.4,10.5a.18.18,0,0,0,.041.1c0,.012,0,.025,0,.037.8,5.834,3.529,11.137,5.125,16.751a10.393,10.393,0,0,0-5.941-4c-.229-.057-.327.3-.1.354a10.026,10.026,0,0,1,6.333,4.779c0,.006.009.009.012.014a30.515,30.515,0,0,1,.623,3.1c.574,3.963.248,8.119-1.9,11.588-.125.2.193.386.317.185,2.828-4.569,2.548-9.929,1.286-14.978",
    transform: "translate(-605.895 -118.017)",
    fill: "#8cc2e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M139.7,155.067c-1.217,1.652-8.121,1.087-8.121,1.087s-2.156-1.309-1.606-2.437a2.677,2.677,0,0,1,1.387-1.057c.516-.257.953-.532.907-1.173-.092-1.283-1.878-1.65-1.191-4.311s1.971-5.168,3.256-4.144.519,2.646,1.758,3.289,2.156-.674,3.3.061-.184,3.386-.367,4.9a1.679,1.679,0,0,0,.193.986c.446.9,1.4,1.556.481,2.8",
    transform: "translate(-106.05 -116.59)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M147.875,160.015a5.543,5.543,0,0,0-1.953,2.532c-.7-1.861-2.384-3.342-2.176-5.468.023-.235-.344-.233-.367,0-.186,1.9,1.082,3.3,1.884,4.9a4.253,4.253,0,0,1,.306,3.435c-.125.389-.259.775-.394,1.16a3.483,3.483,0,0,0-2.683-1.055c-.235.011-.236.378,0,.367a3.134,3.134,0,0,1,2.545,1.08c-.179.5-.36,1-.536,1.505-.078.223.276.32.354.1.582-1.662,1.643-3.594,1.248-5.4a5.145,5.145,0,0,1,1.956-2.831c.189-.137.006-.456-.185-.317",
    transform: "translate(-116.197 -128.107)",
    fill: "#8cc2e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M396.9,64.525a5.333,5.333,0,0,1,1.072,2.991c.148,1.442-.428,3.217-.245,4.606s.03,3.163-1.8,3.286a4.654,4.654,0,0,1-3.217-1.224s-.7-7.066-.667-7.219a20.037,20.037,0,0,1,1.315-2.08c.092-.061,3.547-.36,3.547-.36",
    transform: "translate(-320.086 -52.683)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M418.915,144.076a7.512,7.512,0,0,1,2.664,1.552c.734.887,1.086,2.929,1.82,5.284a47.866,47.866,0,0,1,1.224,5.2s-4.221-3.584-4.527-3.582-.979-2.047-1.009-2.444a11.869,11.869,0,0,1-.52-3.334c.184-1.071.348-2.676.348-2.676",
    transform: "translate(-341.721 -117.634)",
    fill: "#8cc2e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M385.268,71.577a1.422,1.422,0,0,1,1.367,1.339c.134,2.348.184,7.109-1.573,7.476a11.974,11.974,0,0,1-5.135-.437c-.114-.219.13-8.576.13-8.576Z",
    transform: "translate(-310.174 -58.279)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M400.585,105.992a.215.215,0,0,1,.2.287,1.286,1.286,0,0,1-2.314-.088.215.215,0,0,1,.217-.271Z",
    transform: "translate(-325.33 -86.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M380.927,114.2l-.11.723-.173,1.123-.437,2.863-2.178.576s-1.112-1.118-1.18-1.2l-.745-.057c.117-.046.7-4.64.7-4.64Z",
    transform: "translate(-307.078 -92.74)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M368.924,128.91l1.82,1.374,1.206,6.778s-3.745-.412-3.841-.466-6.223-4.955-6.235-5.108,2.945-2.96,2.945-2.96a3.44,3.44,0,0,0,1.03.36c.211-.047,3.076.022,3.076.022",
    transform: "translate(-295.459 -104.94)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M391.837,119.323l-.165,1.076a3.318,3.318,0,0,1-.87-.248,2.463,2.463,0,0,1-1.169-1c-.129-.3.3-.3.964-.075a7.43,7.43,0,0,0,1.241.244",
    transform: "translate(-318.105 -97.095)",
    fill: "#f58a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M350.345,132.831s-1.2.729-2.029,1.218-3.334.728-3.15,2.431a90.292,90.292,0,0,0,2.63,10.3,55.989,55.989,0,0,1,1.591,7.188c0,.092,11.929.856,11.929.856l.336-11.287a16.1,16.1,0,0,0-.627-2.96,23.387,23.387,0,0,1-1.453-2.852,14.309,14.309,0,0,0-.275-2.528,20.337,20.337,0,0,0-3.315-2.239s1.042,4.282-.323,4.614c-2.4.581-5.314-4.74-5.314-4.74",
    transform: "translate(-281.81 -108.453)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M338.805,144.911a4.918,4.918,0,0,0-2.2,2.11c-.551,1.331.287,5.414,1.428,8.626s1.83,5.368,2.288,5.689a4.07,4.07,0,0,0,2.936-.229c.413-.413-1.56-12.342-1.7-12.618s-2.752-3.578-2.752-3.578",
    transform: "translate(-274.684 -118.316)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M369.967,58.673a2.269,2.269,0,0,1-1.651,1.9c-1.438.275-2.6.275-3.12.887a3.315,3.315,0,0,0-.184,2.967c.4.918.951,2.677-.258,3.51a2.415,2.415,0,0,1-3.6-1c-.489-1.407.275-2.906.489-4.16s-.571-4.93,1.325-6.123a7.207,7.207,0,0,1,5.62-.882c2.017.367,2.782,1.071,3.21,1.8s-1.836,1.1-1.836,1.1",
    transform: "translate(-294.745 -45.37)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M358.645,219.468c.275.092,4.451,1.376,4.451,1.376l.367,1.508-1.972.725H355.74a2.688,2.688,0,0,1-1.675-.567,1.132,1.132,0,0,1-.23-.228,5.638,5.638,0,0,1-.861-2.819s5.4-.086,5.671.005",
    transform: "translate(-288.193 -179.155)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M429.937,193.855h-18.23l3.032-10.585a1.307,1.307,0,0,1,1.257-.947h16.038a.91.91,0,0,1,.875,1.16Z",
    transform: "translate(-336.147 -148.861)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M366.374,240.394h9.176v-1.071h-8.106a1.071,1.071,0,0,0-1.071,1.071",
    transform: "translate(-299.134 -195.4)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M819.838,467.344a1.329,1.329,0,0,0,.618.279.479.479,0,0,1-.618-.279",
    transform: "translate(-669.374 -381.573)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M322.622,247.573v46.791a2.418,2.418,0,0,1-2.417,2.417H228.718V245.156h91.487a2.417,2.417,0,0,1,2.417,2.417",
    transform: "translate(-186.742 -200.163)",
    fill: "#8cc2e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M566.668,247.573v46.791a2.418,2.418,0,0,1-2.417,2.417H527.677l19.773-51.625h16.8a2.417,2.417,0,0,1,2.417,2.417",
    transform: "translate(-430.833 -200.163)",
    fill: "#71a7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M104.337,245.156v51.625H78.672a2.294,2.294,0,0,1-2.294-2.294V247.45a2.294,2.294,0,0,1,2.294-2.294Z",
    transform: "translate(-62.36 -200.163)",
    fill: "#71a7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M611.361,492.842l-.178,2.648a1.788,1.788,0,0,0,1.308.357c.864-.061,1.287.459,1.5.069a11.126,11.126,0,0,0,.178-2.506Z",
    transform: "translate(-499.013 -402.391)",
    fill: "#ffb49c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M591.353,500.561c-.494-.185-1.936.07-2.466-.3-.674-.472-.884-.246-1.023,0a17.37,17.37,0,0,1-3.023,2.288,2.223,2.223,0,0,0-1.6,1.6c-.186,1.021,4.743.635,5.069.552s.326-.414.558-.359a.284.284,0,0,1,.2.185.228.228,0,0,0,.2.151c.49.012,1.846.041,1.941,0a8.8,8.8,0,0,0,.124-2.26,10.608,10.608,0,0,0,.017-1.852",
    transform: "translate(-476.192 -408.223)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M662.031,492.842l-.178,2.648a1.789,1.789,0,0,0,1.308.357c.864-.061,1.287.459,1.5.069a11.122,11.122,0,0,0,.178-2.506Z",
    transform: "translate(-540.384 -402.391)",
    fill: "#ffb49c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M642.006,500.535c-.494-.185-1.919.1-2.448-.276-.674-.472-.883-.245-1.023,0a17.381,17.381,0,0,1-3.023,2.288,2.222,2.222,0,0,0-1.6,1.6c-.186,1.021,4.743.635,5.069.552s.325-.414.558-.359a.284.284,0,0,1,.2.185.227.227,0,0,0,.2.15c.49.012,1.846.041,1.941,0a8.788,8.788,0,0,0,.124-2.26,10.605,10.605,0,0,0,0-1.877",
    transform: "translate(-517.563 -408.223)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M638.678,345.282h15.454a1.84,1.84,0,0,0,1.839-1.84v-8.525a1.84,1.84,0,0,0-1.839-1.84H638.678a1.84,1.84,0,0,0-1.84,1.84v8.525a1.84,1.84,0,0,0,1.84,1.84",
    transform: "translate(-519.96 -271.948)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M684.918,298.31s.016.384.095,1.745.376,2.072-.373,2.713c-.691.59-2.675.111-2.675.111l.487-4.432a8.315,8.315,0,0,1,.756-.993c.074.006,1.709.856,1.709.856",
    transform: "translate(-556.805 -242.862)",
    fill: "#f58a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M683.3,297.781l.045,1.167a.587.587,0,0,1-.371.567,2.722,2.722,0,0,1-1.8.152,2.391,2.391,0,0,1-1.595-1.275,7.065,7.065,0,0,1,.108-1.37Z",
    transform: "translate(-554.845 -242.509)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M671.72,318.789a2.492,2.492,0,0,1,4.98,0h.826a3.318,3.318,0,0,0-6.632,0Z",
    transform: "translate(-547.765 -257.659)",
    fill: "#36457a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M512.24,138.973a11.016,11.016,0,0,1-.665-1.721,3.476,3.476,0,0,0-1.239-1.9c-.6-.436-.964-.922-.986-.161-.025.833.772.872.7,1.376s-1.828.023-2.218-.757-.757-1.537-1.055-1.354a3.879,3.879,0,0,0-.393,2.936,6.1,6.1,0,0,0,2.113,2.776,7.2,7.2,0,0,0,2.179,1.193Z",
    transform: "translate(-413.349 -109.755)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M529.21,155.973l-.759-.887a.587.587,0,0,0-.658-.164,2.721,2.721,0,0,0-1.428,1.113,2.393,2.393,0,0,0-.306,2.019,7.071,7.071,0,0,0,1.009.933Z",
    transform: "translate(-429.424 -126.457)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M672.3,136.313a29.489,29.489,0,0,1,1.858,6.166c.642,3.487,1.1,10.706,1.285,12.419a72.837,72.837,0,0,1-.918,11.532c-.367.918-1.055.734-2.225.734a5.162,5.162,0,0,1-2.271-.642l-1.652-10s1.376-11.134,1.468-12.082,2.455-8.124,2.455-8.124",
    transform: "translate(-545.708 -111.296)",
    fill: "#36457a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M611.4,258.136c-.358,7.633-1.488,37.62-1.523,38.211-.042.763-.668.69-1.736.431-.809-.2-1.868.341-2.228-.152s-2.116-25.67-2.621-34.382a.1.1,0,0,0-.055-.092.1.1,0,0,0-.138.092s0,.018,0,.051c-.569,10.391-1.942,33.582-1.969,34.052-.042.763-.668.69-1.736.431-.809-.2-1.883,0-2.243-.492-.426-.582-2.659-36.7-2.742-39.817a22.2,22.2,0,0,1,.551-5.555h8.371l.005,2.09a18.119,18.119,0,0,1,.373-2.09s7.325.139,7.328.162a22.549,22.549,0,0,1,.33,2.79,37.526,37.526,0,0,1,.035,4.271",
    transform: "translate(-485.308 -204.864)",
    fill: "#f8e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M602.487,50.9s-.765,9.574,2.242,9.613c1.915.025,6.129-.557,6.241-.8s-.838-9.227-.838-9.227Z",
    transform: "translate(-491.842 -41.215)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M626.86,101.594c-.059.106-1.051,1.512-1.051,1.512l-3.713-.248-1.137-4.8,5.084-1.532s.717,5.186.815,5.07Z",
    transform: "translate(-506.994 -78.809)",
    fill: "#ffab8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M650.711,271.265c-.358,7.633-1.488,37.62-1.523,38.211-.042.763-.668.69-1.736.431-.809-.2-1.868.341-2.228-.152s-2.116-25.67-2.621-34.382a.1.1,0,0,0-.055-.092c.56-.365,3.168-1.268,4.741-2.966a20.446,20.446,0,0,0,3.223-5.28s.062-.016.165-.04a37.572,37.572,0,0,1,.035,4.271",
    transform: "translate(-524.622 -217.993)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M600.229,41.885a3.5,3.5,0,0,1-.619-2.982c.088-.6.046-2.248-1.378-2.179a2.248,2.248,0,0,1-2.2-3.269c.784-2.086,2.127-1.906,3.34-1.865s3.023.565,3.888.654,2.344-.247,3.119,1.038c1,1.662.205,4.813-.274,8.075-.058.4-.358,2.072-.432,2.485a.435.435,0,0,1-.1.217c-.231.254-.987.666-2.976-1.1-.714-.633-1.919-.5-2.363-1.078",
    transform: "translate(-486.464 -25.774)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M613.874,109.542a12.071,12.071,0,0,1,1.3-2.4,7.95,7.95,0,0,1,3.258-.734c.918.031,2.138-.03,2.644.52a7.525,7.525,0,0,1,.965,2.172Z",
    transform: "translate(-501.21 -86.874)",
    fill: "#afdef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M588.637,119.6a2.273,2.273,0,0,1,1.1-1.963c1.735-1.132,5.14-3.093,8.084-3.22,4.156-.179,8.756,3.071,9.369,4.012s-.513,11.46-.513,13.257,1.411,10.413.7,11.354-3.99,1.959-7.872,1.788-9.4-.57-10.1-1.254.293-9.151.293-12.473c0-2.519-.963-8.733-1.056-11.5",
    transform: "translate(-480.604 -93.416)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M568.805,132a5.139,5.139,0,0,0-2.07,2.2c-.551,1.365-4.588,12.285-3.579,14.121s2.859,2.414,3.4,1.835c2.466-2.661,3.283-6.642,4.1-8.969a44.04,44.04,0,0,0,1.376-4.694C572.461,134.412,570.817,132.675,568.805,132Z",
    transform: "translate(-459.669 -107.773)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M532.225,157.937c-.4-.387-1.124-.115-1.59.193a2.306,2.306,0,0,0-.919,1.023,4.587,4.587,0,0,0-.375,2.784c.275.5,6.8,8.2,6.8,8.2l.914-.387.734-5.139v-.895Z",
    transform: "translate(-432.102 -128.795)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M596.945,134.043a2.336,2.336,0,0,0-2.552-.975.184.184,0,0,0,.1.354c1.571-.461,2.585,1.108,2.677,2.477a12.656,12.656,0,0,1-.474,3.54,31.984,31.984,0,0,1-2.449,6.945c-.1.212.214.4.317.185a30.359,30.359,0,0,0,2.9-9.281,4.5,4.5,0,0,0-.52-3.246",
    transform: "translate(-485.167 -108.574)",
    fill: "#36457a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M563.239,185.969a7.936,7.936,0,0,0-1.079,3.152c-.029.234.339.232.367,0a7.494,7.494,0,0,1,1.029-2.967.184.184,0,0,0-.317-.185",
    transform: "translate(-458.986 -151.767)",
    fill: "#36457a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M262.1,175.172h-9.727V160.458a1.017,1.017,0,0,1,1.017-1.017h7.693a1.017,1.017,0,0,1,1.017,1.017Z",
    transform: "translate(-206.058 -130.179)",
    fill: "#f8e8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M245.23,216.906l-1.606,5.185h1.606Z",
    transform: "translate(-198.912 -177.097)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M267.2,170.7h-6.3a.184.184,0,1,1,0-.367h6.3a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -139.07)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M265.038,179.546H260.9a.184.184,0,1,1,0-.367h4.135a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -146.294)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M289.3,179.546h-1.33a.184.184,0,1,1,0-.367h1.33a.184.184,0,0,1,0,.367",
    transform: "translate(-234.969 -146.294)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M262.234,188.394H260.9a.184.184,0,1,1,0-.367h1.33a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -153.519)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M277.989,188.394h-3.872a.184.184,0,1,1,0-.367h3.872a.184.184,0,1,1,0,.367",
    transform: "translate(-223.658 -153.519)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M267.2,197.242h-6.3a.184.184,0,1,1,0-.367h6.3a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -160.743)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M263.715,206.089H260.9a.184.184,0,0,1,0-.367h2.811a.184.184,0,0,1,0,.367",
    transform: "translate(-212.871 -167.966)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M283.034,206.089H280.3a.184.184,0,1,1,0-.367h2.738a.184.184,0,0,1,0,.367",
    transform: "translate(-228.703 -167.966)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M267.2,214.937h-6.3a.184.184,0,1,1,0-.367h6.3a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -175.19)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M278.418,223.785h-3.776a.184.184,0,1,1,0-.367h3.776a.184.184,0,1,1,0,.367",
    transform: "translate(-224.088 -182.414)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M262.568,223.785H260.9a.184.184,0,1,1,0-.367h1.665a.184.184,0,1,1,0,.367",
    transform: "translate(-212.87 -182.414)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M264.631,232.632H260.9a.184.184,0,1,1,0-.367h3.728a.184.184,0,0,1,0,.367",
    transform: "translate(-212.87 -189.638)",
    fill: "#dbccca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M774.888,453.107h-4.4a4.465,4.465,0,0,1-4.656-3.687l-1.054-10.31a2.446,2.446,0,0,1,2.632-2.488h10.654a2.442,2.442,0,0,1,2.63,2.506l-1.152,10.324a4.472,4.472,0,0,1-4.653,3.655",
    transform: "translate(-624.409 -356.489)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M130.97,217.4h-2.936a4.909,4.909,0,0,1-4.909-4.909,1.331,1.331,0,0,1,1.331-1.331h10.094a1.331,1.331,0,0,1,1.331,1.331,4.909,4.909,0,0,1-4.909,4.909",
    transform: "translate(-100.527 -172.403)",
    fill: "#53689c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 0.367,
    height: 51.625,
    transform: "translate(41.793 44.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M473.536,206.778a.975.975,0,0,1-1.062.878.772.772,0,0,1-.7-.878.984.984,0,0,1,1.062-.878c.581.117.695.393.695.878",
    transform: "translate(-385.194 -168.101)",
    fill: "#3e538a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M356.519,162.519c-4.177.332-6.319-3.8-7.185-7.251-.445-1.775-.673-3.627-1.262-5.363-.4-1.167-1.2-2.253-2.553-2.159-.234.016-.236.383,0,.367,2.283-.159,2.6,3.306,2.942,4.925a26.346,26.346,0,0,0,1.4,5.023c1.156,2.688,3.524,5.075,6.656,4.826.234-.019.236-.386,0-.367",
    transform: "translate(-281.963 -120.625)",
    fill: "#8cc2e6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReception);
export default __webpack_public_path__ + "static/media/reception.93dd7e91c2638518b3eca83b25b167e3.svg";
export { ForwardRef as ReactComponent };